import { render, staticRenderFns } from "./PointHasErr.vue?vue&type=template&id=0f5d912f&"
import script from "./PointHasErr.vue?vue&type=script&lang=ts&"
export * from "./PointHasErr.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports